@if (technicianLivePosition.active) {
  <div class="marker_root">
    <div class="marker hover_parent" [style.background]="conicBackground || 'rgb(68, 68, 68)'">
      <div class="icon_background">
        @if (technicianLivePosition.current_action === "driving") {
          <fa-icon [icon]="faCar"></fa-icon>
        }
        @if (technicianLivePosition.current_action === "finished") {
          <fa-icon [icon]="faCheck"></fa-icon>
        }
        @if (technicianLivePosition.current_action === "working") {
          <fa-icon [icon]="faWrench"></fa-icon>
        }
        @if (technicianLivePosition.current_action === "home_end") {
          <fa-icon [icon]="faHome"></fa-icon>
        }
        @if (technicianLivePosition.current_action === "home_start") {
          <fa-icon [icon]="faHome"></fa-icon>
        }
      </div>
      <div class="marker_content black_gradient_background_no_hover show_on_parent_hover vertical_flex">
        <h6 class="horizontal_flex">
          Aktueller Status:
          @if (technicianLivePosition.current_action === "home_start") {
            Tour Start
          }
          @if (technicianLivePosition.current_action === "working") {
            Auftrag bearbeiten
          }
          @if (technicianLivePosition.current_action === "home_end") {
            Tour Ende
          }
          @if (technicianLivePosition.current_action === "driving") {
            Fahrt
          }
          @if (technicianLivePosition.current_action === "finished") {
            Auftrag erledigt
          }
        </h6>
        <div>
          <b>Ab:</b>
          {{ PATimeControl.Instance.minutesToTimeString(technicianLivePosition.action_start.time_minutes) }}Uhr
          <i>({{ technicianLivePosition.action_start.is_estimated ? "Geschätzt" : "Bestätigt" }})</i>
        </div>
        @if (technicianLivePosition.action_end) {
          <div>
            <b>Bis:</b>
            {{ PATimeControl.Instance.minutesToTimeString(technicianLivePosition.action_end.time_minutes) }}Uhr
            <i>(Geschätzt)</i>
          </div>
        }
      </div>
    </div>
  </div>
}
